/**
 * Created by 胡长伟 on 2020-02-15.
 */
import { Utils } from '../../app.base'
import { Vue } from '../../app.vues'

/**
 * 动态html包装器（可渲染模板和纯html可触发函数）
 */
Vue.component('swb-html-wrapper-x', {
    props: {
        root: {//渲染的根标签tagName
            type: String,
            default: 'span'
        },
        preWrap: {//是否保留空白符、换行等信息
            type: Boolean,
            default: false
        },
        html: {//要渲染的纯html或模板
            default: ''
        },
        asTpl: {//是否当做模板（而不作为html）
            type: Boolean,
            default: true
        },
        data: {//数据对象（click）
            type: Object,
            default: null
        },
        //作为html时
        handler: {//(name, data, srcTagName) 纯html渲染时，单击按钮、链接、图片 触发 等
            type: Function,
            default: null
        },
        handlerX: {//(srcElement) 纯html渲染时，单击按钮、链接、图片 触发 等 之外
            type: Function,
            default: null
        },
        //作为模板时
        methods: {
            type: Object,
            default: null,
        },
        //
        onRendered: {
            type: Function,
            default: null
        }
    },
    data: function () {
        return {
            htmlTpl: '',
            htmlData: null
        };
    },
    created() {
        this.setHtmlTpl();
        this.setHtmlData();
    },
    mounted() {
        if(this.onRendered) {
            this.onRendered();
        }
    },
    updated() {
        if(this.onRendered) {
            this.onRendered();
        }
    },
    watch: {
        html(newVal, oldVal) {
            this.setHtmlTpl();
        },
        data(newVal, oldVal) {
            this.setHtmlData();
        }
    },
    methods: {
        setHtmlTpl() {
            this.htmlTpl = this.html == null ? '' : (this.html + '');
        },
        setHtmlData() {
            this.htmlData = this.data || {};
        },
        getHtmlData(forHtmlEvent = false) {
            if(forHtmlEvent === true) {
                let htmlData = Utils.merge({}, this.htmlData, false);
                delete htmlData['the_given_wrapper_inner__html'];
                return htmlData;
            }
            else {
                return this.htmlData;
            }
        },
        getStartTag() {
            let startHtml = '<' + this.root;
            if(this.preWrap) {
                startHtml += ' style="white-space: pre-wrap;"';
            }
            if(!this.asTpl) {
                startHtml += ' @click="__triggerElClick__($event)" v-html="the_given_wrapper_inner__html"';
            }
            startHtml += '>';
            return startHtml;
        },
        getEndTag() {
            return '</' + this.root + '>';
        },
        getTemplate() {
            if(this.asTpl) {
                return this.getStartTag() + this.htmlTpl + this.getEndTag();
            }
            else {
                return this.getStartTag() + this.getEndTag();
            }
        },
        getMethods() {
            if(this.asTpl) {
                return this.methods || {};
            }
            else {
                return {
                    '__triggerElClick__': this.triggerElClick
                };
            }
        },
        triggerElClick(evnt) {
            //console.log(evnt);
            let srcElement = evnt.srcElement;
            let srcTagName = srcElement.tagName;
            let srcName = srcElement.name || null;
            let useClick = srcElement.getAttribute('use-click');
            if(useClick == null) {
                useClick = srcElement.getAttribute('useclick');
            }
            useClick = useClick != null && useClick != 'false';
            //
            let clickValid = false;
            if(srcTagName == 'BUTTON' || srcTagName == 'A' || (srcTagName == 'INPUT' && srcElement.type == 'BUTTON') || useClick) {
                clickValid = true;
                //
                if(typeof this.handler == 'function') {
                    this.handler(srcName, this.getHtmlData(true), srcTagName);
                }
            }
            else if(srcTagName == 'IMG') {
                let srcParent = srcElement.parentNode;
                if(srcParent != null && (srcParent.tagName == 'A' || srcParent.tagName == 'BUTTON')) {
                    clickValid = true;
                    //
                    try {//如果是图片则触发为A或BUTTON的父元素的点击事件
                        srcParent.click();
                    }
                    catch(ex) {
                        //
                    }
                }
            }
            //
            if(!clickValid) {
                if(typeof this.handlerX == 'function') {
                    this.handlerX(srcElement);
                }
            }
        }
    },
    render: function (createElement) {
        if(!this.asTpl) {
            this.htmlData['the_given_wrapper_inner__html'] = this.htmlTpl;
        }
        //
        let dataFunc = this.getHtmlData;
        let template = this.getTemplate();
        let methods = this.getMethods();
        //console.log(template);
        //
        return createElement({
            data: dataFunc,
            template: template,
            methods: methods
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/compo/ctrl/HtmlWrapperX.js
// module id = 3511
// module chunks = 1